import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { saveReturnTo } from "./returnTo";

/**
 * Giữ `ncc.auth.returnTo` luôn phản ánh route đang đứng.
 *
 * <p>Sau khi `initialize()` ghim `redirectUri` về `/`, Keycloak luôn trả người dùng về gốc —
 * vị trí thật chỉ còn nằm ở phía app. Không thể móc vào từng đường đăng nhập lại để ghi nó:
 * keycloak-js tự đẩy sang Keycloak ở các nhánh nội bộ (`clearToken()` → `login-required`,
 * `authentication_expired`, 400 từ endpoint token) mà không đi qua `login()` của app.</p>
 *
 * <p>Vì vậy thay vì rình các đường redirect, ta để giá trị LUÔN đúng sẵn: cập nhật mỗi lần
 * điều hướng. Cách này cũng xoá luôn vấn đề cũ — ghi một lần lúc khởi động rồi để cũ dần khi
 * người dùng đi lại trong SPA.</p>
 *
 * <p>Chỉ mount trong nhánh đã xác thực. Route công khai (`PublicApp`) không có phiên đăng nhập
 * nên không được chạm vào khoá này.</p>
 */
export function RouteMemory(): null {
  const { pathname, search, hash } = useLocation();

  useEffect(() => {
    saveReturnTo(`${pathname}${search}${hash}`);
  }, [pathname, search, hash]);

  return null;
}
